/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import { createBrowserHistory, createMemoryHistory } from 'history';

const BOOKMARK_KEY = 'bookmark';
let memoryHistory = null;

export const saveBookmark = () => {
  if (memoryHistory && typeof window !== 'undefined') {
    window.localStorage.setItem(
      BOOKMARK_KEY,
      JSON.stringify({
        appVersion: window.App.version,
        appBuildNumber: window.App.build,
        location: memoryHistory.location,
      }),
    );
  }
};

const getBookmark = () => {
  if (typeof window !== 'undefined') {
    try {
      const bookmarkString = window.localStorage.getItem(BOOKMARK_KEY);
      if (bookmarkString) {
        const bookmark = JSON.parse(bookmarkString);
        if (
          bookmark.appVersion === window.App.version &&
          bookmark.appBuildNumber === window.App.build
        ) {
          return bookmark.location;
        }
      }
    } catch (err) {
      console.warn('Failed to check bookmark', err);
    } finally {
      // Remove the bookmark. If we crash the user will restart to the main menu.
      window.localStorage.removeItem(BOOKMARK_KEY);
    }
  }
  return null;
};

const createHistory = () => {
  if (
    typeof window !== 'undefined' &&
    !!window.history &&
    !window.cordova &&
    window.location.protocol !== 'file:'
  ) {
    return createBrowserHistory();
  }

  // When running in Cordova we use file:// URLs so must use the memory history
  const bookmark = getBookmark();
  // We make sure that there is something in the history before the bookmark so
  // that the back link has somewhere to go.
  memoryHistory = createMemoryHistory({
    initialEntries: bookmark ? ['/', bookmark] : ['/'],
    initialIndex: bookmark ? 1 : 0,
  });
  return memoryHistory;
};

export default createHistory();
